/* Sight Optics navigation: desktop panels + mobile accordion. No dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile accordion ---------- */
  /* Capture phase + stopPropagation: Dawn's header-drawer attaches a "close drawer" click handler to every <button>
     inside the drawer, which would shut the whole drawer when an accordion row is tapped. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sn-m-toggle]');
    if (!t) return;
    e.stopPropagation();
    var item = t.closest('.sn-m-item');
    if (!item) return;
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    item.querySelectorAll(':scope > .sn-m-row [data-sn-m-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }, true);

  /* ---------- Desktop panels ---------- */
  var nav = document.querySelector('[data-sn-nav]');
  if (!nav) return;

  /* Panel images are lazy; fetch them once the page is idle (or on first interaction) so panels never open blank. */
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    nav.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  nav.addEventListener('pointerenter', warm, { once: true });
  nav.addEventListener('focusin', warm, { once: true });
  window.addEventListener('load', function () {
    if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 2500);
  });

  var CLOSE_DELAY = 120;
  var timers = new WeakMap();
  var lastPointer = 'mouse';

  function trig(li) { return li.querySelector(':scope > [data-sn-trigger]'); }
  function setExpanded(li, v) { var t = trig(li); if (t) t.setAttribute('aria-expanded', v ? 'true' : 'false'); }

  function close(li) {
    clearTimeout(timers.get(li));
    li.classList.remove('is-open');
    setExpanded(li, false);
    li.querySelectorAll('[data-sn-item].is-open').forEach(function (c) { c.classList.remove('is-open'); setExpanded(c, false); });
  }
  function open(li) {
    clearTimeout(timers.get(li));
    var parent = li.parentElement;
    if (parent) parent.querySelectorAll(':scope > [data-sn-item].is-open').forEach(function (s) { if (s !== li) close(s); });
    li.classList.add('is-open');
    setExpanded(li, true);
  }
  function closeAll() { nav.querySelectorAll('[data-sn-item].is-open').forEach(close); }
  function scheduleClose(li) {
    clearTimeout(timers.get(li));
    timers.set(li, setTimeout(function () { close(li); }, CLOSE_DELAY));
  }

  nav.querySelectorAll('[data-sn-item]').forEach(function (li) {
    li.addEventListener('pointerenter', function (e) {
      lastPointer = e.pointerType || 'mouse';
      if (lastPointer === 'mouse') open(li);
    });
    li.addEventListener('pointerleave', function (e) {
      if ((e.pointerType || 'mouse') === 'mouse') scheduleClose(li);
    });
    li.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || lastPointer; });

    var t = trig(li);
    if (!t) return;
    t.addEventListener('click', function (e) {
      var isButton = t.tagName === 'BUTTON';
      var keyboard = e.detail === 0;
      var isOpen = li.classList.contains('is-open');
      if (lastPointer !== 'mouse' && !keyboard) {
        /* touch / pen: first tap opens, second tap on a link navigates, on a button closes */
        if (!isOpen) { e.preventDefault(); open(li); }
        else if (isButton) { close(li); }
        return;
      }
      if (isButton) {
        /* mouse hover already opened it; keyboard toggles */
        if (keyboard) { isOpen ? close(li) : open(li); }
      }
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(li);
        var first = li.querySelector(':scope > .sn-panel a[href], :scope > .sn-panel button');
        if (first) first.focus();
      }
    });
  });

  nav.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openItems = nav.querySelectorAll('[data-sn-item].is-open');
    if (!openItems.length) return;
    var inner = openItems[openItems.length - 1];
    var t = trig(inner);
    close(inner);
    if (t) t.focus();
    e.stopPropagation();
  });

  nav.addEventListener('focusout', function (e) {
    var to = e.relatedTarget;
    nav.querySelectorAll('[data-sn-item].is-open').forEach(function (li) {
      if (!to || !li.contains(to)) close(li);
    });
  });

  document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(); });
  window.addEventListener('scroll', closeAll, { passive: true });
})();
